import getDefaultComposeFormat from 'owa-editor/lib/utils/getDefaultComposeFormat';
export default function getDefaultComposeContentBlock() {
    var emptyDiv = document.createElement('div');
    emptyDiv.appendChild(document.createElement('br'));
    var elementStyle = emptyDiv.style;
    var defaultFormat = getDefaultComposeFormat();
    if (defaultFormat.fontFamily) {
        elementStyle.fontFamily = defaultFormat.fontFamily;
    }
    if (defaultFormat.fontSize) {
        elementStyle.fontSize = defaultFormat.fontSize;
    }
    if (defaultFormat.textColor) {
        elementStyle.color = defaultFormat.textColor;
    }
    if (defaultFormat.bold) {
        elementStyle.fontWeight = 'bold';
    }
    if (defaultFormat.italic) {
        elementStyle.fontStyle = 'italic';
    }
    if (defaultFormat.underline) {
        elementStyle.textDecoration = 'underline';
    }
    return emptyDiv.outerHTML;
}
//# sourceMappingURL=getDefaultComposeContentBlock.js.map